import React, { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from "react-redux";
import EmojiPickerApp from "./EmojiPickerApp";
// import VoiceMessage from "./VoiceMessage";
import Attachments from "./Attachments";
import { SendIcon } from "../../svg";
import Input from "./Input";
import { ClipLoader } from "react-spinners";
import { sendMessage } from "../../redux/features/chat/chatSlice";
import {
	getLoginStatus, getUser, selectIsLoggedIn, selectUser,
} from "../../redux/features/auth/authSlice";
import { FilterUser } from "../hiddenLinks";
import SocketContext from "../../context/SocketContext";
import CannedMessagePicker from "../CannedMessages/CannedMessagePicker";

const ChatActions = ({ socket }) => {
	const dispatch = useDispatch();
	const [showPicker, setShowPicker] = useState(false);
	const [showAttachments, setShowAttachments] = useState(false);
	const [showCannedPicker, setShowCannedPicker] = useState(false);
	const [loading, setLoading] = useState(false);
	const [message, setMessage] = useState("");
	const [isEnabled, setIsEnabled] = useState(true);
	const [defaultUsers, setDefaultUsers] = useState([]);
	const [selectedQuery, setSelectedQuery] = useState("");

	const { activeConversation, isLoading } = useSelector((state) => state.chat);
	const { user, users } = useSelector((state) => state.auth);
	// const { token } = user;
	const isLoggedIn = useSelector(selectIsLoggedIn);
	// const user = useSelector(selectUser);
	// useEffect(() => {
	//     dispatch(getLoginStatus());
	//     if (isLoggedIn && user === null) {
	//       dispatch(getUser());
	//     }

	// }, [dispatch, isLoggedIn, user]);

	useEffect(() => {
		if (message === "") {
			setSelectedQuery("");
		}
	}, [message]);

	const textRef = useRef();
	const values = {
		message,
		chat_id: activeConversation._id,
		files: [],
		// token,
	};

	const SendMessageHandler = async (e) => {
		e.preventDefault();
		if (!message.trim()) {
			return;
		}

		setLoading(true);
		try {
			let newMsg = await dispatch(sendMessage(values));

			if (newMsg.payload && !newMsg.error) {
				// Only emit socket event if message was saved successfully
				console.log('📤 Emitting message via socket:', newMsg.payload._id);
				socket.emit("send message", newMsg.payload);
				setMessage("");
			} else {
				console.error('❌ Failed to send message:', newMsg.error);
				// Message will still be visible to sender via Redux, but won't be sent to others
			}
		} catch (error) {
			console.error('❌ Error sending message:', error);
		} finally {
			setLoading(false);
		}
	};

	const handleCannedMessageSelect = (description) => {
		setMessage(description);
		setShowCannedPicker(false);
	};

	return (
		<>
			{isEnabled ? (

				<div className="inputSec">
					<form onSubmit={(e) => SendMessageHandler(e)}>
						<div className="inputBtn">
							<ul>
								{/*<li>
              	<VoiceMessage />
              </li>*/}
								<EmojiPickerApp
									textRef={textRef}
									message={message}
									setMessage={setMessage}
									showPicker={showPicker}
									setShowPicker={setShowPicker}
									setShowAttachments={setShowAttachments}
								/>
								<Attachments
									showAttachments={showAttachments}
									setShowAttachments={setShowAttachments}
									setShowPicker={setShowPicker}
								/>
								<FilterUser>
									<li style={{ position: 'relative' }}>
										<button
											type="button"
											className="canned-msg-btn"
											onClick={() => setShowCannedPicker(!showCannedPicker)}
											title="Canned Messages"
										>
											<i className="fa fa-file-text-o" style={{ fontSize: '18px' }}></i>
										</button>
										{showCannedPicker && (
											<CannedMessagePicker onSelect={handleCannedMessageSelect} />
										)}
									</li>
								</FilterUser>
							</ul>
							<Input message={message} setMessage={setMessage} textRef={textRef} />
							<button type="submit" className="btn" disabled={!message || isLoading}>
								{isLoading && loading ? (
									<ClipLoader color="#E9EDEF" size={20} />
								) : (
									<SendIcon />
								)}
							</button>
						</div>
					</form>
				</div>
			) : (
				<p className="disabledInputBar">Component is disabled</p>
			)}

		</>
	)
}

const ChatActionsWithSocket = (props) => (
	<SocketContext.Consumer>
		{(socket) => <ChatActions {...props} socket={socket} />}
	</SocketContext.Consumer>
);
export default ChatActionsWithSocket;